export const entryPhotoStrings = {
  highlights: 'Highlights',
  addHighlight: 'Add highlight photo',
  removeHighlight: 'Remove highlight photo',
  shareHighlights: 'Share new highlights with trip guests',
  albums: 'Photo albums',
  addAlbumLink: 'Add album link',
  emptyAlbums: 'Keep your photos in your favorite album service and link them here.',
  albumName: 'Album name',
  albumLink: 'Album link',
  sharedAlbum: 'Visible to people this trip is shared with',
  albumStorageNote: 'Hobtalk stores the link, not the photos in this album.',
  addAlbum: 'Add album',
  editAlbum: 'Edit album',
  saveAlbum: 'Save album',
  removeAlbumPrompt: (label) => `Remove ${label}? This will not delete photos from the album provider.`,
  removePhotoPrompt: 'Remove highlight photo?',
  storage: (used, limit) => `Photo storage: ${used} of ${limit} MB`,
};
